import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarOrganizadorConfiguracion } from '../../../actions/configuracion';

const EliminarOrganizador = ({ organizador, reestablecerOrganizador }) => {

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (organizador && organizador._id) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [organizador]);

    const handleClose = () => {
        setShow(false);
        reestablecerOrganizador(null);
    };

    const handleEliminar = async (tipo) => {
        if (!organizador || !organizador._id) return;

        const resp = await dispatch(
            eliminarOrganizadorConfiguracion({ id: organizador._id, tipo })
        );

        if (resp && resp.success) {
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <div className="modal-header">
                <h5 className="modal-title">Eliminar organizador</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"
                ></button>
            </div>

            <div className="modal-body">
                <p>
                    ¿Deseas eliminar a <strong>{organizador?.nombre}</strong>?
                </p>

                <div className="d-flex flex-column align-items-center">
                    <div className="mb-2">
                        <button
                            type="button"
                            className="btn btn-danger me-2"
                            onClick={handleClose}
                        >
                            ✖ No
                        </button>

                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => handleEliminar(1)}
                        >
                            ✔ Sí, solo organizador
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => handleEliminar(2)}
                    >
                        ✔ Sí, organizador y ubicaciones
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default EliminarOrganizador;
